import { Component } from "react"
import PropTypes from "prop-types"
import { ListItemButton, ListItemIcon, ListItemText, Checkbox } from "@mui/material"

export default class FacetListItem extends Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    count: PropTypes.number.isRequired,
    selected: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
  }

  onClick = () => {
    const { id, onClick } = this.props
    onClick(id)
  }

  render() {
    const { selected, label, count } = this.props
    return <ListItemButton
      className="facet-list-item"
      onClick={this.onClick}
    >
      <ListItemIcon className="facet-list-icon">
        <Checkbox
          color="primary"
          fontSize="large"
          tabIndex={-1}
          disableRipple
          checked={selected}
        />
      </ListItemIcon>
      <ListItemText>
        {`${label} (${count})`}
      </ListItemText>
    </ListItemButton>
  }
}
